module.exports = __webpack_public_path__ + "./fonts/icon_yes.ffbf3181c9224e79620e335b1fba94ca.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_yes.svg
// module id = ./assets/images/icon_yes.svg
// module chunks = 0